<template>
  <div id="grid-validaciones-especificacion">
    <v-flex>
      <v-toolbar color="white" dark flat dense cad>
        <v-toolbar-title class="indigo--text"
          >Configuración de la jornada</v-toolbar-title
        ><v-btn
          :loading="loading"
          color="primary"
          @click="viewEspecificacion(-1)"
          >Ver todos los registros</v-btn
        >
      </v-toolbar>
    </v-flex>
    <v-container grid-list-xl fluid>
      <v-layout>
        <carga-masiva
          v-if="usuarioLoggedTipe != 'PROVEEDOR'"
          :apiValidateDocument="apiValidateDocument"
          :apiSaveDocument="apiSaveDocument"
          :apiDownloadDocument="apiDownloadDocument"
          :templateTitle="templateTitle"
          :tipoCarga="tipoCarga"
        ></carga-masiva>
      </v-layout>
      <v-layout>
        <v-flex lg12>
          <div v-if="loading">
            <loading></loading>
          </div>
          <div v-if="alerta">
            <alert-empty></alert-empty>
          </div>
          <v-spacer></v-spacer>
          <template>
            <v-data-table
              :headers="headers"
              :items="itemsArchivos"
              :rows-per-page-items="rowsPerPageItems"
              class="elevation-1"
              hide-actions
            >
              <template v-slot:items="props">
                <tr>
                  <td class="text-xs-left">{{ props.item.nombre }}</td>
                  <td class="text-xs-left">
                    {{ props.item.usuario.username }}<br />{{
                      props.item.usuario.nombre
                    }}
                    {{ props.item.usuario.apellido }}
                  </td>
                  <td class="text-xs-left">{{ props.item.fechaCreacion }}</td>
                  <td class="text-xs-left">{{ props.item.numTotalHoras }}</td>
                  <td class="text-xs-left">
                    {{ props.item.numTotalPersonas }}
                  </td>
                  <td class="text-xs-left">{{ props.item.fechaIni }}</td>
                  <td class="text-xs-left">{{ props.item.fechaFin }}</td>
                  <td>
                    <v-btn
                      depressed
                      outline
                      icon
                      fab
                      dark
                      color="green darken-4"
                      small
                      title="Ver Detalle"
                      @click="viewEspecificacion(props.item.id)"
                    >
                      <v-icon>remove_red_eye</v-icon>
                    </v-btn>
                    <v-btn
                      v-if="(usuarioLoggedTipe == 'AGENCIA' || usuarioLoggedTipe == 'ADMINISTRADOR') && getCodigoPerfil() != 'LEC' && !isContratoCerrado()"
                      depressed
                      outline
                      icon
                      fab
                      dark
                      color="red"
                      small
                      title="Eliminar archivo"
                      @click="confirmaEliminar(props.item.id)"
                    >
                      <v-icon>clear</v-icon>
                    </v-btn>
                  </td>
                </tr>
              </template>
            </v-data-table>
            <!-- LEYENDA -->
            <v-card-actions class="pb-3">
              <v-spacer></v-spacer>
              <v-btn
                class="btn-sigas"
                depressed
                outline
                icon
                fab
                dark
                color="green darken-4"
                small
              >
                <v-icon>remove_red_eye</v-icon></v-btn
              >
              &nbsp;Ver Detalle
              <v-btn
                v-if="(usuarioLoggedTipe == 'AGENCIA' || usuarioLoggedTipe == 'ADMINISTRADOR') && getCodigoPerfil() != 'LEC' && !isContratoCerrado()"
                depressed
                outline
                icon
                fab
                dark
                color="red"
                small
                title="Eliminar archivo"
              >
                <v-icon>clear</v-icon></v-btn
              >
              &nbsp;Eliminar archivo
            </v-card-actions>

            <v-flex xs12 sm6>
              <v-text-field
                value=""
                label="Total de Registros"
                v-model="totalRegs"
                disabled
              ></v-text-field>
            </v-flex>
            <div class="text-center pt-2">
              <v-pagination
                @input="changePage(page)"
                v-model="page"
                :length="pages"
                :total-visible="9"
                circle
              >
              </v-pagination>
            </div>
          </template>

          <!-- MODAL CONFIRMACION BORRAR -->
          <v-dialog v-model="modalConfirm" persistent max-width="600">
            <v-card>
              <v-card-title class="headline"
                >Borrar configuración de la jornada</v-card-title
              >
              <v-card-text>
                <v-flex lg12>
                  <v-card-actions class="pb-3">
                    <v-spacer></v-spacer>
                  </v-card-actions>
                  <div class="text-resp text-xs-center">
                    <i
                      class="fa fa-trash-o text-danger fa-5x pb-3"
                      aria-hidden="true"
                      style="color: #bb0000"
                    ></i
                    ><br />
                    <p>
                      <b
                        >¿Está seguro que quiere borrar todos los registros de
                        configuración de la jornada asociados a este
                        archivo?.</b
                      >
                    </p>
                    <p>Esta acción no de puede deshacer.</p>
                    <v-btn color="primary" flat @click="closeModal()"
                      >Cerrar</v-btn
                    >&nbsp;&nbsp;<v-btn
                      color="primary"
                      @click="showModalBorrar()"
                      >Borrar</v-btn
                    >
                  </div>
                </v-flex>
              </v-card-text>
            </v-card>
          </v-dialog>
          <!-- MODAL BORRAR -->
          <v-form ref="form" lazy-validation>
            <v-dialog v-model="modalBorrar" max-width="500">
              <v-card>
                <v-flex xs10 class="mx-4">
                  <v-card-title class="headline" style="font-weight: bold"
                    >Borrar configuración de la jornada</v-card-title
                  >
                  <v-textarea
                    name="input-7-1"
                    v-model="observaciones"
                    label="Observaciones"
                    value
                    counter
                    maxlength="500"
                  ></v-textarea>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                      color="indigo darken-1"
                      flat="flat"
                      @click="closeModal"
                      >Cancelar</v-btn
                    >
                    <v-btn color="primary" @click="eliminar()">Borrar</v-btn>
                  </v-card-actions>
                </v-flex>
              </v-card>
            </v-dialog>
          </v-form>
        </v-flex>
      </v-layout>

      <!-- ARCHIVOS BORRADOS -->
      <v-flex row>
        <v-flex lg12 xs12>
          <v-toolbar color="white" dark flat dense cad>
            <v-toolbar-title class="indigo--text"
              >Archivos borrados</v-toolbar-title
            >
          </v-toolbar>
        </v-flex>
        <v-flex lg12 xs12 fill-height>
          <div v-if="loadingBorrados">
            <loading></loading>
          </div>
          <div v-if="alertaBorrados">
            <alert-empty></alert-empty>
          </div>
          <v-spacer></v-spacer>
          <template>
            <v-data-table
              :headers="headersBorrados"
              :items="itemsArchivosBorrados"
              :rows-per-page-items="rowsPerPageItemsBorrados"
              class="elevation-1"
              hide-actions
            >
              <template v-slot:items="props">
                <td class="text-xs-left">{{ props.item.nombre }}</td>
                <td class="text-xs-left">
                  {{ props.item.usuarioBorra.username }}<br />{{
                    props.item.usuarioBorra.nombre
                  }}
                  {{ props.item.usuarioBorra.apellido }}
                </td>
                <td class="text-xs-left">{{ props.item.fechaCreacion }}</td>
                <td class="text-xs-left">
                  {{ props.item.usuarioCarga.username }}<br />{{
                    props.item.usuarioCarga.nombre
                  }}
                  {{ props.item.usuarioCarga.apellido }}
                </td>
                <td class="text-xs-left">{{ props.item.fechaCarga }}</td>
                <td class="text-xs-left">{{ props.item.numTotalHoras }}</td>
                <td class="text-xs-left">{{ props.item.numTotalPersonas }}</td>
                <td class="text-xs-left">{{ props.item.fechaIni }}</td>
                <td class="text-xs-left">{{ props.item.fechaFin }}</td>
                <td class="text-xs-left">{{ props.item.observaciones }}</td>
              </template>
            </v-data-table>

            <v-flex xs12 sm6>
              <v-text-field
                value=""
                label="Total de Registros"
                v-model="totalRegsBorrados"
                disabled
              ></v-text-field>
            </v-flex>
            <div class="text-center pt-2">
              <v-pagination
                @input="changePage(pageBorrados)"
                v-model="pageBorrados"
                :length="pagesBorrados"
                :total-visible="9"
                circle
              >
              </v-pagination>
            </div>
          </template>
        </v-flex>
      </v-flex>
    </v-container>
  </div>
</template>
<script>
import axios from "axios";
import Loading from "@/views/ui/Loading.vue";
import AlertEmpty from "@/views/ui/AlertEmpty.vue";
import CargaMasiva from "@/components/CargaMasiva.vue";
import { validationMixin } from "vuelidate";
import { required, maxLength } from "vuelidate/lib/validators";
import { misMixins } from "@/mixins/myMixing.js";
import jwtDecode from "jwt-decode";

export default {
  name: "grid-validaciones-especificacion",

  components: {
    AlertEmpty,
    Loading,
    CargaMasiva,
  },
  props: {},
  mixins: [misMixins, validationMixin],

  data() {
    return {
      loading: false,
      loadingBorrados: false,
      alerta: false,
      alertaBorrados: false,
      dialogLoading: false,
      idContrato: "",
      usuarioLoggedTipe: "",
      headers: [
        { text: "Nombre", align: "left", sortable: false, value: "nombre" },
        { text: "Usuario", sortable: false, value: "Usuario" },
        { text: "Carga", align: "left", sortable: false, value: "carga" },
        { text: "Total horas", sortable: false, value: "horas" },
        { text: "Total personas", sortable: false, value: "horas" },
        { text: "Inicio", sortable: false, value: "inicio" },
        { text: "Termino", sortable: false, value: "termino" },
        { text: "Accion", sortable: false, value: "" },
      ],
      itemsArchivos: [],
      //----CARGA MASIVA---
      apiValidateDocument: "/validaciones/preProcessEspecificacion",
      apiSaveDocument: "/validaciones/saveFileEspecificacion",
      apiDownloadDocument: "/validaciones/downloadTemplateEspecificacion/",
      templateTitle: "Plantilla_Configuracion_Jornada",
      tipoCarga: "CSV",

      //paginacion por DB
      page: 1,
      pages: 1,
      totalRegs: 0,
      rowsPerPageItems: [20],

      //borrar archivo
      idArchivo: -1,
      observaciones: "",
      modalConfirm: false,
      modalBorrar: false,

      //paginacion por DB Borrados
      pageBorrados: 1,
      pagesBorrados: 1,
      totalRegsBorrados: 0,
      rowsPerPageItemsBorrados: [20],
      itemsArchivosBorrados: [],
      headersBorrados: [
        { text: "Nombre", align: "left", sortable: false, value: "nombre" },
        { text: "Usuario carga", sortable: false, value: "Usuario" },
        { text: "Carga", align: "left", sortable: false, value: "carga" },
        { text: "Usuario borra", sortable: false, value: "Usuario" },
        { text: "Borra", align: "left", sortable: false, value: "carga" },
        { text: "Total horas", sortable: false, value: "horas" },
        { text: "Total personas", sortable: false, value: "horas" },
        { text: "Inicio", sortable: false, value: "inicio" },
        { text: "Termino", sortable: false, value: "termino" },
        { text: "Observaciones", sortable: false, value: "termino" },
      ],
    };
  },

  validations: {
    observaciones: { required, maxLength: maxLength(500) },
  },
  watch: {},

  created() {
    // console.log("EspecificacionValidaciones");
    this.usuarioLoggedTipe = this.$store.getters.userLogged.tipo;
    this.idContrato = this.$store.getters.contratoStored;

    // console.log("especific validaciones idcontrato::" + this.idContrato);
    this.loadData(true);
    this.loadDataBorrados(true);
  },
  mounted() {},
  computed: {
    observacionesErrors() {
      const errors = [];
      if (!this.$v.observaciones.$dirty) return errors;
      !this.$v.observaciones.required &&
        errors.push("Las observaciones son obligatorias.");
      return errors;
    },
  },
  methods: {
    getCodigoPerfil() {
      const token = localStorage.getItem("token");
      const decoded = jwtDecode(token);
      const user = decoded.dto;
      // console.log("DEVODED USER:", user);
      return user.perfil.codigo;
    },
    isContratoCerrado() {
      const contratoCerradoConId = JSON.parse(localStorage.getItem("contratoCerradoConId"));
      if (contratoCerradoConId && contratoCerradoConId.idContrato === this.idContrato) {
        return contratoCerradoConId.cerrado;
      }
      return false;
    },
    changePage(page) {
      this.page = page <= 0 || page > this.pages ? this.page : page;
      this.loadData();
    },
    async loadArchivos() {
      let body = {
        idContrato: this.idContrato,
        idUsuario: this.$store.getters.userLogged.id,
        pageSize: 20,
        pageNumber: this.page,
      };
      return await axios
        .post("/validaciones/getArchivos/", body)
        .then(function (response) {
          return response.data;
        })
        .catch((error) => {
          if (error) {
            console.log(error.response.data);
            /*  window.getApp.$emit("ERROR_EXCEPTION", error.response.data.message); */
          }
          return [];
        });
    },
    async loadData(limpiar) {
      if (limpiar) this.page = 1;
      this.loading = true;

      let result = await this.loadArchivos();
      this.itemsArchivos = result.archivosEspec;

      if (result.totalRegistros > 0) {
        this.totalRegs = result.totalRegistros;
        this.pages = Math.ceil(this.totalRegs / this.rowsPerPageItems);
        this.alerta = false;
        this.botonDescarga = false;
      } else {
        this.totalRegs = 0;
        this.page = 1;
        this.pages = 0;
        this.alerta = true;
        this.botonDescarga = true;
      }
      this.loading = false;
    },
    async loadArchivosBorrados() {
      let body = {
        idContrato: this.idContrato,
        idUsuario: this.$store.getters.userLogged.id,
        pageSize: 20,
        pageNumber: this.page,
      };
      return await axios
        .post("/validaciones/getArchivosBorrados/", body)
        .then(function (response) {
          return response.data;
        })
        .catch((error) => {
          if (error) {
            console.log(error.response.data);
            /*  window.getApp.$emit("ERROR_EXCEPTION", error.response.data.message); */
          }
          return [];
        });
    },
    async loadDataBorrados(limpiar) {
      if (limpiar) this.page = 1;
      this.loadingBorrados = true;

      let result = await this.loadArchivosBorrados();
      this.itemsArchivosBorrados = result.archivosBorradosEspec;

      if (result.totalRegistros > 0) {
        this.totalRegsBorrados = result.totalRegistros;
        this.pagesBorrados = Math.ceil(
          this.totalRegsBorrados / this.rowsPerPageItemsBorrados
        );
        this.alertaBorrados = false;
      } else {
        this.totalRegsBorrados = 0;
        this.pageBorrados = 1;
        this.pagesBorrados = 0;
        this.alertaBorrados = true;
      }
      this.loadingBorrados = false;
    },
    viewEspecificacion(id) {
      this.loading = true;
      setTimeout(() => {
        this.$router.push({
          name: "ValArchivoEspecData",
          query: {
            idArchivoEspecificacion: id,
          },
        });
      }, 1000);
    },
    closeModal() {
      this.idArchivo = -1;
      this.observaciones = "";
      this.modalConfirm = false;
      this.modalBorrar = false;
    },
    confirmaEliminar(id) {
      this.idArchivo = id;
      this.observaciones = "";
      this.modalConfirm = true;
    },
    showModalBorrar() {
      this.modalConfirm = false;
      this.modalBorrar = true;
    },
    eliminar() {
      let body = {
        idContrato: this.idContrato,
        idUsuario: this.$store.getters.userLogged.id,
        idArchivo: this.idArchivo,
        observaciones: this.observaciones,
      };
      axios
        .post("/validaciones/borrarArchivo/", body)
        .then((response) => {
          window.getApp.$emit("APP_SAVE");
          this.closeModal();
          this.loadData(true);
          this.loadDataBorrados(true);
        })
        .catch((error) => {
          console.log("st::err:" + JSON.stringify(error, null, 2));
          if (error.response) {
            console.log(" error.response::" + error.response);
            window.getApp.$emit("ERROR_EXCEPTION", error.response.data.message);
          }
        });
    },
    changePage(page) {
      this.page = page <= 0 || page > this.pages ? this.page : page;
      this.loadData(false);
    },
    reload() {
      setTimeout(() => {
        this.$parent.$parent.reloadDocumento();
      }, 1000);
    },
  },
};
</script>